'use client';

import { useState } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';

import { RequestForQuotationFlyout } from '../../request-for-quotation/components/flyout/request-for-quotation/request-for-quotation-flyout';
import { ProductPriceCardItem } from '../models/product-price-card-item.model';

import { ProductPriceCard } from './product-price-card';

interface Props {
   productPriceCardItems: ProductPriceCardItem[];
   productDetailBaseRoute: string;
   quoteDetailBaseRoute: string;
   tdsAnchor: string | undefined;
   channel: string;
   showShoppingCartBtn: boolean;
   showOfflinePrices: boolean;
   showRequestQuoteOption: boolean;
}

export const ProductPriceListClient = ({
   productPriceCardItems,
   productDetailBaseRoute,
   quoteDetailBaseRoute,
   tdsAnchor,
   channel,
   showShoppingCartBtn,
   showOfflinePrices,
   showRequestQuoteOption
}: Props) => {
   const [flyoutOpen, setFlyoutOpen] = useState(false);
   const [selectedItem, setSelectedItem] = useState<ProductPriceCardItem | undefined>(undefined);

   const handleRequestNewQuote = async (value: ProductPriceCardItem) => {
      setSelectedItem(value);
      setFlyoutOpen(true);
   };

   const userPermissions = {
      hasGuestPermission: false,
      hasPendingPermission: false,
      hasAnonymousPermission: false,
      hasVerifiedPermission: true
   };

   const color = selectedItem?.color
      ? {
           colorName: selectedItem.color,
           producerColorCode: selectedItem.producerColorCode,
           desiredColor: undefined
        }
      : undefined;

   return (
      <>
         <Box direction="column" gap="sm">
            {productPriceCardItems.map((value, index) => (
               <ProductPriceCard
                  /* eslint-disable-next-line react/no-array-index-key */
                  key={`${value.productId}-${index}`}
                  productPriceCardItemId={`${value.productId}-${index}`}
                  productPriceCardItem={value}
                  productDetailBaseRoute={productDetailBaseRoute ?? ''}
                  quoteDetailBaseRoute={quoteDetailBaseRoute}
                  tdsAnchor={tdsAnchor}
                  channel={channel}
                  isOverview={!!quoteDetailBaseRoute}
                  showShoppingCartBtn={showShoppingCartBtn}
                  showOfflinePrices={showOfflinePrices}
                  showRequestQuoteOption={showRequestQuoteOption}
                  onRequestQuote={() => handleRequestNewQuote(value)}
               />
            ))}
         </Box>

         {selectedItem && (
            <RequestForQuotationFlyout
               key={selectedItem.productId}
               open={flyoutOpen}
               color={color}
               productId={selectedItem.productId.toString()}
               productDescription={selectedItem.description}
               isCustomerProduct
               userPermissions={userPermissions}
               type="QUICK_QUOTE"
               from="MY_PRICES"
               onClose={() => setFlyoutOpen(false)}
               onComplete={() => setFlyoutOpen(false)}
            />
         )}
      </>
   );
};
